import React from 'react'
import styled from 'styled-components'
import { dimensions, light, spacing } from '~/constants/theme'

/** `fax` uses the new styles for list item components */
export type StyleType = 'default' | 'fax'

const selectedColor = light.gray400

const RootWrapper = styled.div<{ selected: boolean; styleType: StyleType }>`
  padding: ${(props) => (props.styleType === 'fax' ? 0 : spacing.spacingMD)};
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${(props) =>
    props.styleType === 'fax'
      ? dimensions.xxBorderRadiusSM
      : dimensions.borderRadiusSM};
  margin-top: ${(props) =>
    props.styleType === 'fax' ? spacing.spacingSM : 'auto'};
  margin-right: 'auto';
  margin-bottom: ${(props) =>
    props.styleType === 'fax' ? spacing.spacingSM : 'auto'};
  margin-left: 'auto';
  transition: all 0.1s ease-in-out;
  background-color: ${(props) => {
    if (props.selected) {
      return selectedColor
    }

    if (props.styleType === 'fax') {
      return 'inherit'
    }

    return light.gray200
  }};
  &:hover {
    background-color: ${(props) => {
      // Don't apply hover styles to selected items
      if (props.selected) {
        return selectedColor
      }

      if (props.styleType === 'fax') {
        return light.gray300
      }

      return light.gray400
    }};
  }

  &:active {
    background-color: ${light.dark600};
  }
`

const NewTextDot = styled.div`
  width: ${spacing.spacingLG};
  height: ${spacing.spacingLG};
  margin: ${spacing.spacingSM} 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${dimensions.borderRadiusCircle};
  cursor: pointer;
  background-color: ${light.primaryHover};
`

const ItemWrapper = styled.div<{ height?: string; styleType: StyleType }>`
  width: 100%;
  height: ${(props) => props.height || '100%'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  padding-top: ${spacing.spacingMD};
  padding-right: ${(props) =>
    props.styleType === 'fax' ? spacing.spacingLG : spacing.spacingMD};
  padding-bottom: ${spacing.spacingMD};
  padding-left: ${spacing.spacingMD};
`

const SectionWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const TitleWrapper = styled.div<{ shouldShowUnreadDot?: boolean | null }>`
  display: flex;
  align-items: center;
  padding-left: ${(props) =>
    props.shouldShowUnreadDot === true || props.shouldShowUnreadDot === null
      ? '0px'
      : `${spacing.spacingLG}`};

  > p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const DateWrapper = styled.div`
  margin-left: 10px;
  p {
    white-space: nowrap;
  }
`
interface ListItemProps {
  activated: boolean
  shouldShowUnreadDot?: boolean | null
  title?: string | React.ReactElement
  subTitle?: string | React.ReactElement
  date?: string | React.ReactElement
  time?: string | React.ReactElement
  onClick?: (event: React.MouseEvent) => void
  height?: string
  styleType?: StyleType
  Thumbnail?: React.ReactElement
}
const ListItem = ({
  activated,
  title,
  subTitle,
  date,
  time,
  shouldShowUnreadDot,
  onClick,
  height,
  styleType,
  Thumbnail,
}: ListItemProps) => {
  return (
    <RootWrapper selected={activated} styleType={styleType || 'default'}>
      {shouldShowUnreadDot && <NewTextDot />}
      {Thumbnail}
      <ItemWrapper
        height={height}
        onClick={onClick}
        styleType={styleType || 'default'}
      >
        <SectionWrapper>
          <TitleWrapper shouldShowUnreadDot={shouldShowUnreadDot}>
            {title}
          </TitleWrapper>
          <DateWrapper>{date}</DateWrapper>
        </SectionWrapper>
        <SectionWrapper>
          <TitleWrapper shouldShowUnreadDot={shouldShowUnreadDot}>
            {subTitle}
          </TitleWrapper>
          {time && <DateWrapper>{time}</DateWrapper>}
        </SectionWrapper>
      </ItemWrapper>
    </RootWrapper>
  )
}

export default ListItem
